export { CalendarCheckAlt as default } from './CalendarCheckAlt';
